module.exports = __webpack_public_path__ + "img/Barracuda-NextGen.ad952fe.svg";